module.exports = __webpack_public_path__ + "img/1.07250343.svg";